<template>
    <b-modal modal-class="modal fade" dialog-class="modal-dialog" content-class="modal-content"
             v-model="open" @ok="onOk" @cancel="onCancel" no-close-on-backdrop no-close-on-esc>
        <template slot="modal-header">
            <h5 class="modal-title">
                {{titleText}}
            </h5>
            <button class="btn" type="button" data-dismiss="modal" aria-label="Close">
                <i class="text-muted fas fa-close"></i>
            </button>
        </template>

        {{question}}

        <template slot="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cancelClicked">
              Abbrechen
            </button>
            <button type="button" class="btn btn-primary" @click="okClicked">
                Ja
            </button>
        </template>
    </b-modal>
</template>

<script>
    export default {
        name: "ask-modal",

        data: () => ({
            open: false,
            titleText: "",
            question: "",
            onOk: () => null,
            onCancel: () => null,
            onHidden: () => null
        }),

        methods: {
            ask(question) {
                this.question = question
                this.open = true
                return this
            },
            title(val) {
                this.titleText = val
                return this
            },
            ok(val) {
                this.onOk = val
                return this
            },
            cancel(val) {
                this.onCancel = val
                return this
            },
            cancelClicked() {
                this.onCancel()
                this.open = false
                this.reset()
                return this
            },
            okClicked() {
                this.onOk()
                this.open = false
                this.reset()
                return this
            },
            reset() {
                this.titleText = ""
                this.question = ""
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/modals/Ask.vue